import { CommitteeHeader } from "./CommitteeHeader";

export default CommitteeHeader;
